import { unref } from 'vue';

import i18n from '@/config/i18n';

import getPropertyData from '@/utils/getPropertyData';

import useFilterState from '@/state/useFilterState';
import useSummaryPropertyState from '@/state/useSummaryPropertyState';

const {
  propertySummaryDaysSelected,
} = useFilterState();

const {
  smallScoreCharts,
  funnelCharts,
  kpiCharts,
} = useSummaryPropertyState();

const { t } = i18n.global;

const getReadyChartData = async (charts, saveKeys = []) => {
  let chartsData = charts
    .filter((i) => !i.reportDisabled && i.finished)
    .map(async (i) => {
      const data = {
        id: i.id,
        title: t(unref(i.title) || ''),
      };

      if (saveKeys.length) {
        saveKeys.forEach((key) => {
          data[key] = i[key];
        });
      }

      if (i.getImg && typeof i.getImg === 'function') {
        data.image = await i.getImg();
      }

      return data;
    });

  chartsData = await Promise.all(chartsData);

  return chartsData;
};

const prepareSummaryExportData = async ({ dates }) => {
  const { propertyId, name } = getPropertyData();

  const commonChartKeys = ['diff', 'diffText', 'diffClass'];

  const exportData = {
    name: `Summary (${dates.startDate}_${dates.endDate})`,
    reportTitle: t('{reportTitle} benchmark', { reportTitle: t('Summary') }),
    showCoverCtpDates: false,
    property: {
      id: propertyId,
      name,
    },
    dates: {
      startDate: dates.startDate,
      endDate: dates.endDate,
      ctpDateBegin: dates.ctpDateBegin,
      ctpDateEnd: dates.ctpDateEnd,
    },
    pages: [
      {
        pageLayout: 'scores',
        pageTitle: t('Scores'),
        showVisitDates: false,
        showCtpDates: false,
        showFilters: false,
        items: await getReadyChartData(smallScoreCharts.value, ['lastMonthScore', ...commonChartKeys]),
      },
      {
        pageLayout: 'default',
        pageTitle: t('Conversion Funnel'),
        showVisitDates: true,
        showCtpDates: false,
        showFilters: false,
        items: await getReadyChartData(funnelCharts.value),
      },
      {
        pageLayout: 'kpi',
        pageTitle: propertySummaryDaysSelected.value > 1 ? t('These past {days} days', { days: propertySummaryDaysSelected.value }) : t('Yesterday'),
        showVisitDates: true,
        showCtpDates: true,
        showFilters: false,
        items: await getReadyChartData(kpiCharts.value, ['ownValue', ...commonChartKeys]),
      },
    ],
  };
  return exportData;
};

export default prepareSummaryExportData;
